import React from 'react';
import ReactDOM from 'react-dom';
import BaseComponent from 'foundation/base-component';
import QualifiedPlayerCard from './QualifiedPlayerCard';

export default class QualifiedPlayerCardComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.item = this.options.item;
        this.bg = this.options.bg;
        this.init();
    }

    init() {
        ReactDOM.render(<QualifiedPlayerCard item={this.item} bg={this.bg}/>, this.element);
    }
}
